import type { IconNode } from '../types';

/**
 * @name chameleon
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMjJjLTUgMC05LTQuNS05LTEwUzYgMiAxMSAyYzIuMiAwIDQuMi45IDUuNyAyLjNMMTkuMyAyYzMuMSAzLjEgMy41IDcuOSAxLjMgMTEuNC0uNi45LTEuOS45LTIuNy4xbC0xLjItMS4yQzE1LjIgMTAuOSAxMy4yIDEwIDExIDEwYTYgNiAwIDAgMCAwIDEyIDQgNCAwIDAgMCAwLTggMiAyIDAgMCAwIDAgNCIgLz4KICA8cGF0aCBkPSJNMTQgN2guMDEiIC8+CiAgPGNpcmNsZSBjeD0iMTQuNSIgY3k9IjciIHI9IjMuNSIgLz4KICA8cGF0aCBkPSJNOCAxMC44IDYgMTBsMS0yIiAvPgogIDxwYXRoIGQ9Ik0yMiAyMmEyIDIgMCAwIDEtMi0ydi02LjEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/chameleon
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const chameleon: IconNode = [
  [
    'path',
    {
      d: 'M11 22c-5 0-9-4.5-9-10S6 2 11 2c2.2 0 4.2.9 5.7 2.3L19.3 2c3.1 3.1 3.5 7.9 1.3 11.4-.6.9-1.9.9-2.7.1l-1.2-1.2C15.2 10.9 13.2 10 11 10a6 6 0 0 0 0 12 4 4 0 0 0 0-8 2 2 0 0 0 0 4',
      key: 'htcu8r',
    },
  ],
  ['path', { d: 'M14 7h.01', key: '1imkj4' }],
  ['circle', { cx: '14.5', cy: '7', r: '3.5', key: '1hnybq' }],
  ['path', { d: 'M8 10.8 6 10l1-2', key: 'k7ju5p' }],
  ['path', { d: 'M22 22a2 2 0 0 1-2-2v-6.1', key: 'y7i8hh' }],
];

export default chameleon;
